/**
 * The domain term shown to people. It is "Merchant" in the interface and
 * `Brand` in the code, the API and the data model (DECISIONS.md D52): renaming
 * tables, routes and payload fields would mean a data migration and a breaking
 * API change for a label.
 *
 * Both apps build their wording from here, so the web panel and the field app
 * cannot drift apart. A test fails if the old word reappears in either app's
 * dictionaries.
 */
export const MERCHANT_TERMS = {
    en: {
        one: 'Merchant',
        many: 'Merchants',
        oneLower: 'merchant',
        manyLower: 'merchants',
    },
    ar: {
        /** Indefinite singular: "تاجر جديد". */
        one: 'تاجر',
        /** Definite singular, for labels and column headers: "التاجر". */
        the: 'التاجر',
        /** Definite plural, for titles and navigation: "التجار". */
        many: 'التجار',
        /** Indefinite plural: "تجار جدد". */
        manyIndefinite: 'تجار',
        /** With the preposition ل: ل + التجار contracts to "للتجار" (never "لالتجار"). */
        forMany: 'للتجار',
    },
};
/**
 * Trip wording (one branch, several projects). The owner has not settled it
 * yet, so it lives here once and both apps read it: changing a word here
 * changes it on the phone, in The Engine and in exports.
 */
export const TRIP_TERMS = {
    en: {
        /** The switch under the main visit's project block. */
        additionalVisits: 'Additional visits',
        addVisit: 'Add visit',
        /** One additional project visit (card title before a project is chosen). */
        additionalVisit: 'Additional visit',
        mainVisit: 'Main visit',
        projectBlock: 'Project',
        trip: 'Trip',
    },
    ar: {
        additionalVisits: 'زيارات إضافية',
        addVisit: 'إضافة زيارة',
        additionalVisit: 'زيارة إضافية',
        mainVisit: 'الزيارة الرئيسية',
        projectBlock: 'المشروع',
        trip: 'الجولة',
    },
};
/**
 * Words that must no longer appear in user-facing text. Used by the guard tests
 * in both apps; the code identifiers (`brandId`, `/brands`) are not text and are
 * not checked.
 */
export const RETIRED_MERCHANT_WORDS = [/\bbrands?\b/i, /علام(ة|ات)/, /براند/, /ماركة/];
//# sourceMappingURL=terms.js.map